import { Field, useField, useFormikContext } from 'formik'
import { keyBy } from 'lodash'

import Select from 'components/Select'
import TextBox from 'components/TextBox'

import { TIME_ZONES } from 'resources'
import { createRequiredLabel } from 'utils/formik'

const Info = ({ id, showValidationErrors }) => {
  const timeZones = TIME_ZONES

  const { values, setFieldValue } = useFormikContext()

  const timeZonesByUuid = keyBy(TIME_ZONES, 'uuid')
  const timeZonesByValue = keyBy(TIME_ZONES, 'value')

  const [field, fieldMeta] = useField('localTime')

  return (
    <section id={id}>
      <h3 className="header-title">Info</h3>
      <div className="item-details">
        <div className="text-field">
          <Field
            component={TextBox}
            label={createRequiredLabel('Name')}
            name="name"
            showValidationErrors={showValidationErrors}
          />
        </div>
        <div className="text-field">
          <Field
            component={TextBox}
            label="External Ref ID"
            name="externalRefId"
          />
        </div>
        <div className="text-field">
          <Field
            component={TextBox}
            label="Description"
            name="description"
          />
        </div>
        <div className="text-field">
          <Field
            component={Select}
            options={timeZones}
            handleChange={(value) => {
              setFieldValue(
                'localTime',
                timeZonesByUuid[value]?.value
              )
            }}
            defaultValue={timeZonesByValue[values.localTime]?.uuid}
            label="Time Zone"
            fieldName="localTime"
            name="localTime"
            error={fieldMeta.error}
            showValidationErrors={showValidationErrors}
            dataCy="time-zone"
          />
        </div>
      </div>
    </section>
  )
}

export default Info
